<template>
  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務経歴</h2>
        <p>
          <span v-for="(line, i) in leadLines" :key="i">
            <br v-if="i > 0" />{{ line }}
          </span>
        </p>
        <el-checkbox
          v-if="showOmonajiseki"
          v-model="formatData.notDisplayOmonajiseki"
          >【主な実績】のラベルを表示しない</el-checkbox
        >
      </div>
      <div class="card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <component
              :is="resolvedItemComponent"
              v-for="(item, index) in formatData.jobHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.jobHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :activeHistoryItem="activeHistoryItem"
              :descriptionPlaceholder="descriptionPlaceholder"
              :descriptionMaxLength="descriptionMaxLength"
              @click.native="activateHistoryItem(item.uuid)"
              @add-history-item="addJobHistory"
              @delete-history-item="deleteJobHistory"
              @move-history-item="moveJobHistory"
              @add-project-history-item="addProjectHistory"
              @delete-history-item-detail="deleteHistoryDetail"
              @move-history-item-detail="moveJobHistoryDetail"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addJobHistory()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import HistoryItemJob from '@/components/formats/ShokurekishoParts/HistoryItemJob.vue'
import HistoryItemJobCareer from '@/components/formats/ShokurekishoParts/HistoryItemJob_career.vue'
import HistoryItemJobSkillsheet from '@/components/formats/ShokurekishoParts/HistoryItemJob_skillsheet.vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'
import { useProvidedShokurekishoHistories } from '@/composables/format-edit/useShokurekishoHistories'
import type { BasicData } from '@/utils/format-edit/basicData'

type JobHistoryVariant = 'job' | 'career' | 'skillsheet'

const props = withDefaults(
  defineProps<{
    currentCardId?: string
    basicData: BasicData
    lead?: string
    showOmonajiseki?: boolean
    variant?: JobHistoryVariant
    descriptionPlaceholder?: string
  }>(),
  {
    lead: '今までに在籍した会社の概要を入力しましょう。\n会社ごとに、業務の実績や参加プロジェクトの説明も追加できます。',
    showOmonajiseki: true,
    variant: 'job',
    descriptionPlaceholder: '会社名を入力'
  }
)

const descriptionMaxLength = 80
const formatData = useShokurekishoFormatData()
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useProvidedShokurekishoHistories()

const itemByVariant = {
  job: HistoryItemJob,
  career: HistoryItemJobCareer,
  skillsheet: HistoryItemJobSkillsheet
}

const resolvedItemComponent = computed(() => itemByVariant[props.variant])
const leadLines = computed(() => props.lead.split('\n'))
</script>
